<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "ChipList" });
import Chip from "../chip/Chip.svelte";
import "tailwindcss/tailwind.css";
export let items = [];
export let maxItems = void 0;
export let size = "sm";
export let color = "dark";
export let css = "";
</script>

{#if Array.isArray(items) && items.length > 0}

    <ul class = { `s8-chips ${ css }` } >

        {#each items as item, index }
            {#if maxItems === undefined || index < maxItems}
                <li>
                    <Chip { size } color = { item.color ?? color } >
                        { item.label }
                    </Chip>
                </li>
            {/if}
        {/each}

        {#if maxItems !== undefined && items.length > maxItems }
            <li>
                <Chip color = 'dark' { size }>+ { items.length - maxItems }</Chip>
            </li>
        {/if}
    </ul>

{/if}

<style>
    ul.s8-chips li {
    display: inline
}</style>